export default __webpack_public_path__ + "static/media/san-jose.a1cd7489.jpg";